import React, {Fragment, useEffect, useState} from 'react';
import {GUTTER_SM, MODAL_WIDTH_LG, MODAL_WIDTH_XL} from "../../../styles/constants";
import EnhancedModal from '../../../components/enhanced-modal';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {
    changeDataflowsDetailDataflow,
    closeDataflowsDetailLinkedDataflowDataflowsModal, dataflowsEraseMappingSetInfo,
    hideDataflowsDetail,
    hideDataflowsDetailDsds,
    hideDataflowsDetailLayoutAnnotationsForm,
    openDataflowsDetailLinkedDataflowDataflowsModal,
    pingDataflowsDetailLinkedDataflowEndpoint,
    readDataflowsDetailAgencies,
    readDataflowsDetailDataflow,
    readDataflowsDetailDsdForLayoutAnnotations,
    readDataflowsDetailDsds,
    readDataflowsDetailHierarchicalCodelists,
    readDataflowsDetailLayoutAnnotationsItemsPage,
    readDataflowsDetailLinkedDataflowDataflows,
    readLinkedDataflowSourceDataflow,
    readLinkedDataflowSourceDsdForLayoutAnnotations,
    resetDataflowsDetailLayoutAnnotationsForm,
    resetDataflowsDetailLayoutAnnotationsItemsPage,
    setDataflowsDetailDsd,
    setDataflowsDetailLinkedDataflowDataflow,
    setDataflowsDetailLinkedDataflowEndpoint,
    showDataflowsDataflowClone,
    showDataflowsDataflowDownload,
    showDataflowsDataflowExport,
    showDataflowsDetailDsds,
    showDataflowsDetailLayoutAnnotationsForm,
    submitDataflowsDetailDataflowCreate,
    submitDataflowsDetailDataflowUpdate,
    submitDataflowsDetailLayoutAnnotationsForm,
    unsetDataflowsDetailDsd,
    unsetDataflowsDetailLinkedDataflowDataflow
} from "./actions";
import {Alert, Button, Col, Modal, Row, Tabs} from "antd";
import ArtefactForm, {
  ARTEFACT_FORM_MODE_CREATE,
  ARTEFACT_FORM_MODE_EDIT,
  ARTEFACT_FORM_MODE_READ
} from '../../../components/artefact-form';
import Call from "../../../hocs/call";
import Selector from "../../../components/selector";
import {isArtefactValid} from "../../../utils/artefactValidators";
import ReduxdsdDetailModal from "../../../redux-components/redux-dsd-detail-modal";
import {MM_DATAFLOWS_DSD_DETAIL_PREFIX, MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX} from "./reducer";
import {reuseAction} from "../../../utils/reduxReuse";
import {showDsdDetail} from "../../../redux-components/redux-dsd-detail-modal/actions";
import ArtefactList from "../../../components/artefact-list";
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";
import EndpointsDropdown from "../../../components/endpoints-dropdown";
import {DATAFLOW_TYPE_NORMAL} from "../../../utils/dataflow";
import { getLinkedDataflowSource } from './utils';
import { getArtefactTripletFromString, getArtefactTripletFromUrn, getStringFromArtefactTriplet } from '../../../utils/sdmxJson';
import { ENABLE_CATEGORIZATION } from '../../../constants/generals';
const mapStateToProps = state => ({
  nodes: state.config.nodes,
  nodeId: state.app.endpointId,
  appLanguage: state.app.language,
  isVisible: state.scenes.metaManager.dataflows.isDetailVisible,
  dataflowTriplet: state.scenes.metaManager.dataflows.dataflowTriplet,
  isDataflowValid: state.scenes.metaManager.dataflows.isDataflowValid,
  isAgenciesValid: state.scenes.metaManager.dataflows.isAgenciesValid,
  isDataflowGeneralTabDirty: state.scenes.metaManager.dataflows.isDataflowGeneralTabDirty,
  dataflow: state.scenes.metaManager.dataflows.dataflow,
  agencies: state.scenes.metaManager.dataflows.agencies,
  dsds: state.scenes.metaManager.dataflows.dsds,
  isDsdsListVisible: state.scenes.metaManager.dataflows.isDsdsListVisible,
  dsdDetail: state.scenes.metaManager.dataflows.dsdDetail,
  selectedDsdDetail: state.scenes.metaManager.dataflows.selectedDsdDetail,
  selectedDsdTriplet: state.scenes.metaManager.dataflows.selectedDsdTriplet,
  permissions: state.app.user.permissions,
  dsdForLayoutAnnotations: state.scenes.metaManager.dataflows.dsdForLayoutAnnotations,
  isLayoutAnnotationsFormVisible: state.scenes.metaManager.dataflows.isLayoutAnnotationsFormVisible,
  itemsPageForLayoutAnnotations: state.scenes.metaManager.dataflows.itemsPageForLayoutAnnotations,
  endpointId: state.app.endpointId,
  isLinkedDFEndpointAvailable: state.scenes.metaManager.dataflows.isLinkedDFEndpointAvailable,
  isLinkedDFDataflowsModalOpen: state.scenes.metaManager.dataflows.isLinkedDFDataflowsModalOpen,
  linkedDFDataflows: state.scenes.metaManager.dataflows.linkedDFDataflows,
  sourceDataflow: state.scenes.metaManager.dataflows.sourceDataflow,
  hierarchicalCodelists: state.scenes.metaManager.dataflows.hierarchicalCodelists,
  mappingSetCallbackInfo: state.scenes.metaManager.dataflows.mappingSetCallbackInfo
});

const mapDispatchToProps = dispatch => ({
  onDetailHide: () => dispatch(hideDataflowsDetail()),
  onDetailChange: fields => dispatch(changeDataflowsDetailDataflow(fields)),
  onDetailCreate: dataflow => dispatch(submitDataflowsDetailDataflowCreate(dataflow)),
  onDetailUpdate: (dataflow, keepModalOpen) => dispatch(submitDataflowsDetailDataflowUpdate(dataflow, keepModalOpen)),
  fetchDataflow: dataflowTriplet => dispatch(readDataflowsDetailDataflow(dataflowTriplet)),
  fetchAgencies: allowedAgencies => dispatch(readDataflowsDetailAgencies(allowedAgencies)),
  onDsdsShow: () => dispatch(showDataflowsDetailDsds()),
  onDsdsHide: () => dispatch(hideDataflowsDetailDsds()),
  fetchDsds: () => dispatch(readDataflowsDetailDsds()),
  onDsdDetailShow: dsdTriplet => dispatch(reuseAction(showDsdDetail(dsdTriplet), MM_DATAFLOWS_DSD_DETAIL_PREFIX)),
  onSelectedDsdDetailShow: dsdTriplet => dispatch(reuseAction(showDsdDetail(dsdTriplet), MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX)),
  onDsdSet: dsdTriplet => dispatch(setDataflowsDetailDsd(dsdTriplet)),
  onDsdUnset: () => dispatch(unsetDataflowsDetailDsd()),
  onDownloadShow: (dataflowTriplets, lang) => dispatch(showDataflowsDataflowDownload(dataflowTriplets, lang)),
  onCloneShow: artefactTriplet => dispatch(showDataflowsDataflowClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showDataflowsDataflowExport(sourceTriplet)),
  fetchDsdForLayoutAnnotations: dsdTriplet => dispatch(readDataflowsDetailDsdForLayoutAnnotations(dsdTriplet)),
  onLayoutAnnotationsFormShow: () => dispatch(showDataflowsDetailLayoutAnnotationsForm()),
  onLayoutAnnotationsFormHide: () => dispatch(hideDataflowsDetailLayoutAnnotationsForm()),
  onLayoutAnnotationsFormSubmit: annotations => dispatch(submitDataflowsDetailLayoutAnnotationsForm(annotations)),
  onLayoutAnnotationsFormReset: () => dispatch(resetDataflowsDetailLayoutAnnotationsForm()),
  fetchItemsPageForLayoutAnnotations: ({
                                         codelistTriplet,
                                         language,
                                         pageNum,
                                         pageSize,
                                         searchText,
                                         filters,
                                         sortCol,
                                         sortByDesc
                                       }, endpointId) => dispatch(readDataflowsDetailLayoutAnnotationsItemsPage({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc,
    endpointId
  })),
  resetItemsPageForLayoutAnnotations: () => dispatch(resetDataflowsDetailLayoutAnnotationsItemsPage()),
  onLinkedDFEndpointSet: endpointId => dispatch(setDataflowsDetailLinkedDataflowEndpoint(endpointId)),
  onLinkedDFDataflowSet: dataflowTriplet => dispatch(setDataflowsDetailLinkedDataflowDataflow(dataflowTriplet)),
  onLinkedDFDataflowUnset: () => dispatch(unsetDataflowsDetailLinkedDataflowDataflow()),
  onLinkedDFEndpointPing: endpointId => dispatch(pingDataflowsDetailLinkedDataflowEndpoint(endpointId)),
  onLinkedDFDataflowsModalOpen: () => dispatch(openDataflowsDetailLinkedDataflowDataflowsModal()),
  onLinkedDFDataflowsModalClose: () => dispatch(closeDataflowsDetailLinkedDataflowDataflowsModal()),
  fetchLinkedDFDataflows: endpointId => dispatch(readDataflowsDetailLinkedDataflowDataflows(endpointId)),
  onReadLinkedDataflowSourceDataflow: (endpointId, dataflowTriplet) => dispatch(readLinkedDataflowSourceDataflow(endpointId, dataflowTriplet)),
  onReadLinkedDataflowSourceDsdForLayoutAnnotations : (endpointId, dsdTriplet) => dispatch(readLinkedDataflowSourceDsdForLayoutAnnotations(endpointId, dsdTriplet)),
  fetchHierarchicalCodelists : () => dispatch(readDataflowsDetailHierarchicalCodelists()),
  eraseMappingSetInfo: () => dispatch(dataflowsEraseMappingSetInfo())
});

const selector = (t, onSelectedDsdDetailShow, selectedDsdTriplet, onDsdsShow, onDsdUnset, disabled) =>
  <Selector
    disabled={disabled}
    detailTitle={t('commons.artefact.tabs.general.dsd.selector.detail.title')}
    selectTitle={t('commons.artefact.tabs.general.dsd.selector.select.title')}
    resetTitle={t('commons.artefact.tabs.general.dsd.selector.reset.title')}
    onDetail={() => onSelectedDsdDetailShow(selectedDsdTriplet)}
    onSelect={onDsdsShow}
    onReset={onDsdUnset}
  />;

const DataflowDetail = ({
                           t,
                           nodes,
                           appLanguage,
                           isVisible,
                           dataflowTriplet,
                           isDataflowValid,
                           isAgenciesValid,
                           isDataflowGeneralTabDirty,
                           dataflow,
                           agencies,
                           sourceDataflow,
                           onDetailHide,
                           onDetailChange,
                           onDetailCreate,
                           onDetailUpdate,
                           fetchDataflow,
                           fetchAgencies,
                           dsds,
                           isDsdsListVisible,
                           dsdDetail,
                           selectedDsdTriplet,
                           selectedDsdDetail,
                           onDsdsShow,
                           onDsdsHide,
                           fetchDsds,
                           onDsdDetailShow,
                           onSelectedDsdDetailShow,
                           onDsdSet,
                           onDsdUnset,
                           permissions,
                           endpointId,
                           isLinkedDFEndpointAvailable,
                           isLinkedDFDataflowsModalOpen,
                           linkedDFDataflows,
                           onLinkedDFEndpointSet,
                           onLinkedDFDataflowsModalOpen,
                           onLinkedDFDataflowsModalClose,
                           onLinkedDFDataflowSet,
                           onLinkedDFDataflowUnset,
                           onLinkedDFEndpointPing,
                           fetchLinkedDFDataflows,
                           onDownloadShow,
                           onCloneShow,
                           onExportShow,
                           fetchDsdForLayoutAnnotations,
                           dsdForLayoutAnnotations,
                           isLayoutAnnotationsFormVisible,
                           onLayoutAnnotationsFormShow,
                           onLayoutAnnotationsFormHide,
                           onLayoutAnnotationsFormSubmit,
                           onLayoutAnnotationsFormReset,
                           itemsPageForLayoutAnnotations,
                           fetchItemsPageForLayoutAnnotations,
                           resetItemsPageForLayoutAnnotations,
                           onReadLinkedDataflowSourceDataflow,
                           onReadLinkedDataflowSourceDsdForLayoutAnnotations,
                           hierarchicalCodelists,
                           fetchHierarchicalCodelists,
                           forceDataflowTypeNormal = false,
                           isReadOnly = false,
                           mappingSetCallback = null,
                           mappingSetCallbackInfo = null,
                           eraseMappingSetInfo,
                           hideVariableTabs = false,
                         }) => {

  const [tab, setTab] = useState("general"); 
  const userHasPermissionsAgency = (
    permissions && dataflowTriplet &&
    permissions.agencies.filter(agency => agency === dataflowTriplet.agencyID).length > 0
  );

  const userHasPermissionsToEdit = (
    permissions && dataflowTriplet &&
    permissions.agencies.filter(agency => agency === dataflowTriplet.agencyID).length > 0
  ) && !isReadOnly;

  const node = nodes.find(node => node.general.id === endpointId);
  const linkedDFSource  = getLinkedDataflowSource(node, dataflow, dataflowTriplet);
  const dataflowIsLinked = linkedDFSource.dfId !== null && linkedDFSource.endpointId !== null;

  const maxNumLinkedDF = 2; 
  const [showOnlyGeneralParameters, setShowOnlyGeneralParameters] = useState(false);
  const [sourceDfId, setSourceDfId] = useState(null);
  const [sourceEndPoint, setSourceEndpoint] = useState(null);
  const [hasToReadSourceDataflow, setHasToReadSourceDataflow] = useState(false);  
  const [numLinkedDF, setNumLinkedDF] = useState(0);
  const [firstDataflowRead, setFirstDataflowRead] = useState(false);

    useEffect(() => {
        if (!!mappingSetCallbackInfo && !!mappingSetCallback) {
            mappingSetCallback(mappingSetCallbackInfo);
            eraseMappingSetInfo();
        }
    }, [mappingSetCallback, mappingSetCallbackInfo, eraseMappingSetInfo]);

  useEffect( () => {
    if (!dataflow) {
      setShowOnlyGeneralParameters(false);
      setSourceDfId(null);
      setSourceEndpoint(null);
      setHasToReadSourceDataflow(false);
      setNumLinkedDF(0);
      setFirstDataflowRead(false);
    }
  }, [dataflow]);

  useEffect( () => {
    if (dataflow && !firstDataflowRead) {     
      setSourceDfId(linkedDFSource.dfId);
      setSourceEndpoint(linkedDFSource.endpointId);
      setHasToReadSourceDataflow(dataflowIsLinked);
      setFirstDataflowRead(true);
    }
  }, [dataflow, firstDataflowRead, linkedDFSource, dataflowIsLinked]);

  useEffect( () => {
    if (sourceDataflow && sourceEndPoint) {
      const srcDataflowTriplet = getArtefactTripletFromUrn(sourceDataflow.urn);
      const endPoint = nodes.find(node => node.general.id === sourceEndPoint);
      if (endPoint) {
        const sourceInfo  = getLinkedDataflowSource(endPoint, sourceDataflow, srcDataflowTriplet);
        const isLinked = sourceInfo.dfId !== null && sourceInfo.endpointId !== null;
        if (isLinked) {
          setSourceEndpoint(sourceInfo.endpointId);
          setSourceDfId(sourceInfo.dfId);
        }
        setHasToReadSourceDataflow(isLinked);
      } else {
        setSourceEndpoint(null);
        setSourceDfId(null);
        setHasToReadSourceDataflow(false);
        setNumLinkedDF(0);
        setShowOnlyGeneralParameters(true);
      }            
    }
  }, [sourceDataflow, nodes, sourceEndPoint]);


  useEffect(() => {
    if (sourceEndPoint && sourceDfId && hasToReadSourceDataflow) {
        const sEndPoint = nodes.find(node => node.general.id === sourceEndPoint);
        if (sEndPoint) { 
          if (numLinkedDF < maxNumLinkedDF) {
            onReadLinkedDataflowSourceDataflow(sourceEndPoint, getArtefactTripletFromString(sourceDfId));
            setNumLinkedDF(numLinkedDF + 1);
            setHasToReadSourceDataflow(false);
          } else {
            setHasToReadSourceDataflow(false);
            setShowOnlyGeneralParameters(true);
          }                               
        } else {
          setSourceEndpoint(null);
          setSourceDfId(null);
          setHasToReadSourceDataflow(false);
          setNumLinkedDF(0);
          setShowOnlyGeneralParameters(true);
        };
      }    
  }, [sourceDfId, sourceEndPoint, nodes,hasToReadSourceDataflow,numLinkedDF, 
    onReadLinkedDataflowSourceDataflow]);

  const handleFetchDsdForLayoutAnnotations = () => {               
    if (sourceEndPoint && sourceDataflow) {
      const endPoint = nodes.find(node => node.general.id === sourceEndPoint);
      if (endPoint) {
        const dsdTriplet = getArtefactTripletFromUrn(sourceDataflow.structure);
        onReadLinkedDataflowSourceDsdForLayoutAnnotations(sourceEndPoint, dsdTriplet);      
      } 
    }   
  }

  const handleLinkedEndpointSelect = (endpointId) => {
    setSourceEndpoint(endpointId);
    onLinkedDFEndpointSet(endpointId);
  }

  const handleLinkedDfSelect = (df) => {
    setSourceDfId(getStringFromArtefactTriplet(df));
    setHasToReadSourceDataflow(true);
    onLinkedDFDataflowSet(df);
  }

  const LinkedDFNodeSelect =
    dataflow && dataflow.isExternalReference
      ? (
        <EndpointsDropdown
          disabled={dataflowTriplet}
          endpoints={nodes.filter(ep => ep.general.id !== endpointId)}
          endpointId={linkedDFSource.endpointId}
          onEndpointSet={(endPointId) => handleLinkedEndpointSelect(endPointId)}
          onNodePing={() => onLinkedDFEndpointPing(linkedDFSource.endpointId)}
          isEndpointAvailable={isLinkedDFEndpointAvailable}
          doNotGoHome
          canBeNull
          fullWidth
        />
      )
      : null;

  const LinkedDFDataflowSelector =
    !!dataflow && dataflow.isExternalReference
      ? (
        <Call cb={onLinkedDFEndpointPing} cbParam={linkedDFSource.endpointId}
              disabled={!linkedDFSource.endpointId || nodes.find(ep => ep.general.id === linkedDFSource.endpointId) === undefined}>
          <Selector
            disabled={!!dataflowTriplet || !isLinkedDFEndpointAvailable || !linkedDFSource.endpointId}
            selectTitle={t("scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.select.title")}
            resetTitle={t("scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.reset.title")}
            onSelect={onLinkedDFDataflowsModalOpen}
            onReset={onLinkedDFDataflowUnset}
            value={
              linkedDFSource.dfId
                ? linkedDFSource.dfId
                : null
            }
          />
          {linkedDFSource.endpointId && isLinkedDFEndpointAvailable && (
            <EnhancedModal
              visible={isLinkedDFDataflowsModalOpen}
              onCancel={onLinkedDFDataflowsModalClose}
              title={t('scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.modal.title')}
              width={MODAL_WIDTH_LG}
              footer={<Button
                onClick={onLinkedDFDataflowsModalClose}>{t('commons.buttons.close.title')}</Button>}
            >
              <Call
                cb={fetchLinkedDFDataflows}
                cbParam={linkedDFSource.endpointId}
                disabled={!isLinkedDFDataflowsModalOpen}
              >
                {linkedDFDataflows &&
                linkedDFDataflows.find(({agencyID}) => !permissions.agencies.includes(agencyID)) && (
                  <Alert
                    type="warning"
                    showIcon
                    message={t('scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.list.alert.someDataflowsAreDisabledForUnallowedAgency')}
                  />
                )}
                <ArtefactList
                  artefacts={linkedDFDataflows}
                  onRowClick={(df) => handleLinkedDfSelect(df)}
                  getIsDisabledRow={({agencyID}) => !permissions.agencies.includes(agencyID)}
                />
              </Call>
            </EnhancedModal>
          )}
        </Call>
      )
      : null;

  return (
    <Call
      cb={fetchDataflow}
      cbParam={dataflowTriplet}
      disabled={isDataflowValid}
    >
      <Call
        cb={fetchAgencies}
        cbParam={permissions ? permissions.agencies : undefined}
        disabled={isAgenciesValid}
      >
        <EnhancedModal
          visible={isVisible}
          width={MODAL_WIDTH_XL}
          title={
            dataflowTriplet !== null
              ? (
                userHasPermissionsToEdit
                  ? t('scenes.metaManager.dataflows.detail.title.editMode.title', {triplet: dataflowTriplet})
                  : t('scenes.metaManager.dataflows.detail.title.viewMode.title', {triplet: dataflowTriplet})
              )
              : t('scenes.metaManager.dataflows.detail.title.createMode.title')
          }
          onCancel={onDetailHide}
          footer={
            <div>
              <Button onClick={onDetailHide}>{t('commons.buttons.close.title')}</Button>
              {dataflowTriplet === null || userHasPermissionsToEdit
                ? (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (!isArtefactValid(dataflow) || (dataflow.isExternalReference && linkedDFSource.endpointId === null)) {
                        Modal.warning({
                          title: t('commons.alerts.invalidForm.title'),
                          content: t('commons.alerts.invalidForm.content')
                        });
                      } else {
                        if (dataflowTriplet !== null) {
                          onDetailUpdate(dataflow)
                        } else {
                          onDetailCreate(dataflow)
                        }
                      }
                    }}
                  >
                    {t("commons.buttons.save.title")}
                  </Button>
                )
                : null}
            </div>
          }
          withDataLanguageSelector
        >
          <DataLanguageConsumer>
            {dataLanguage => {
              const lang = dataLanguage || appLanguage;
              return dataflowTriplet
                ? ( // edit dataflow
                  <Fragment>
                    {permissions && !userHasPermissionsAgency && (
                      <Alert
                        type="warning"
                        showIcon
                        message={t('commons.artefact.alerts.hasNotAgencyPermission')}
                      />
                    )}
                    <Row type="flex" gutter={GUTTER_SM} justify={"end"}>
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="download"
                          size="small"
                          title={t('commons.artefact.buttons.download.title')}
                          onClick={() => onDownloadShow([dataflowTriplet], lang)}
                        />
                      </Col>
                      {permissions && (
                        <Col>
                          <Button
                            type="primary"
                            shape="circle"
                            icon="copy"
                            size="small"
                            title={t('commons.artefact.buttons.clone.title')}
                            onClick={() => {
                              if (dataflow.isExternalReference) {
                                Modal.error({title: t("scenes.metaManager.dataflows.errors.cannotCloneVirtualDF.title")});
                              } else {
                                onCloneShow(dataflowTriplet)
                              }
                            }}
                          />
                        </Col>
                      )}
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="export"
                          size="small"
                          title={t('commons.artefact.buttons.export.title')}
                          onClick={() => onExportShow(dataflowTriplet)}
                        />
                      </Col>
                    </Row>
                    <Tabs
                      activeKey={tab}
                      onTabClick={
                        key => {
                          if (!isArtefactValid(dataflow) || (dataflow.isExternalReference && linkedDFSource.endpointId === null)) {
                            Modal.warning({
                              title: t('commons.alerts.invalidForm.title'),
                              content: t('commons.alerts.invalidForm.content')
                            });
                          } else {
                            setTab(key);
                            if (key === "categorisations") {
                              Modal.error({title: t('errors.notImplemented')});
                            }
                            if (isDataflowGeneralTabDirty) {
                              onDetailUpdate(dataflow, true)
                            }
                          }
                        }
                      }
                    >
                      <Tabs.TabPane
                        key="general"
                        tab={t('commons.artefact.tabs.general.title')}
                      >
                        {dataflow && (
                          <ArtefactForm // edit dataflow
                            artefact={dataflow}
                            mode={userHasPermissionsToEdit ? ARTEFACT_FORM_MODE_EDIT : ARTEFACT_FORM_MODE_READ}
                            agencies={agencies}
                            onChange={onDetailChange}
                            DSDInput={
                                dataflow.dataflowType === DATAFLOW_TYPE_NORMAL
                                  ? selector(t, onSelectedDsdDetailShow, selectedDsdTriplet, onDsdsShow, onDsdUnset, true)
                                  : null
                            }
                            dsdDimensions={dsdForLayoutAnnotations && dsdForLayoutAnnotations.dimensions}
                            dsdAttributes={dsdForLayoutAnnotations && dsdForLayoutAnnotations.attributes}
                            isDataflow
                            isLayoutAnnotationsFormVisible={isLayoutAnnotationsFormVisible}
                            dataflow={dataflow}
                            dsdForLayoutAnnotations={dsdForLayoutAnnotations}
                            onLayoutAnnotationsFormShow={onLayoutAnnotationsFormShow}
                            onLayoutAnnotationsFormHide={onLayoutAnnotationsFormHide}
                            onLayoutAnnotationsFormSubmit={onLayoutAnnotationsFormSubmit}
                            onLayoutAnnotationsFormReset={onLayoutAnnotationsFormReset}
                            fetchDsdForLayoutAnnotations={(dsdTriplet) => dataflow.isExternalReference
                              ? handleFetchDsdForLayoutAnnotations()
                              : fetchDsdForLayoutAnnotations(dsdTriplet)}
                            itemsPageForLayoutAnnotations={itemsPageForLayoutAnnotations}
                            fetchItemsPageForLayoutAnnotations={(value)=> fetchItemsPageForLayoutAnnotations(value, sourceEndPoint)}
                            resetItemsPageForLayoutAnnotations={resetItemsPageForLayoutAnnotations}
                            canBeSpecialDataflow
                            VirtualDFNodeInput={LinkedDFNodeSelect}
                            VirtualDFDataflowInput={LinkedDFDataflowSelector}
                            showOnlyGeneralParameters={showOnlyGeneralParameters}
                            hierarchicalCodelists={hierarchicalCodelists}
                            fetchHierarchicalCodelists={fetchHierarchicalCodelists}
                            hideVariableTabs={hideVariableTabs}
                          />
                        )}
                      </Tabs.TabPane>
                      {ENABLE_CATEGORIZATION && <Tabs.TabPane key="categorisations" tab={t("commons.artefact.tabs.categorisations.title")} />}
                    </Tabs>
                  </Fragment>
                )
                : ( // create dataflow
                  <ArtefactForm
                    forceDataflowTypeNormal={forceDataflowTypeNormal}
                    artefact={dataflow}
                    mode={ARTEFACT_FORM_MODE_CREATE}
                    agencies={agencies}
                    onChange={onDetailChange}
                    DSDInput={
                      dataflow.dataflowType === DATAFLOW_TYPE_NORMAL
                        ? selector(t, onSelectedDsdDetailShow, selectedDsdTriplet, onDsdsShow, onDsdUnset)
                        : null                     
                    }
                    dsdDimensions={dsdForLayoutAnnotations && dsdForLayoutAnnotations.dimensions}
                    dsdAttributes={dsdForLayoutAnnotations && dsdForLayoutAnnotations.attributes}
                    isDataflow
                    isLayoutAnnotationsFormVisible={isLayoutAnnotationsFormVisible}
                    dataflow={dataflow}
                    dsdForLayoutAnnotations={dsdForLayoutAnnotations}
                    onLayoutAnnotationsFormShow={onLayoutAnnotationsFormShow}
                    onLayoutAnnotationsFormHide={onLayoutAnnotationsFormHide}
                    onLayoutAnnotationsFormSubmit={onLayoutAnnotationsFormSubmit}
                    onLayoutAnnotationsFormReset={onLayoutAnnotationsFormReset}
                    fetchDsdForLayoutAnnotations={(dsdTriplet) => {
                      dataflow.isExternalReference
                      ? handleFetchDsdForLayoutAnnotations()
                      : fetchDsdForLayoutAnnotations(dsdTriplet)                    
                    }}
                    itemsPageForLayoutAnnotations={itemsPageForLayoutAnnotations}
                    fetchItemsPageForLayoutAnnotations={(value)=> fetchItemsPageForLayoutAnnotations(value, sourceEndPoint)}
                    resetItemsPageForLayoutAnnotations={resetItemsPageForLayoutAnnotations}
                    canBeSpecialDataflow
                    VirtualDFNodeInput={LinkedDFNodeSelect}
                    VirtualDFDataflowInput={LinkedDFDataflowSelector}
                    showOnlyGeneralParameters={showOnlyGeneralParameters}
                    hierarchicalCodelists={hierarchicalCodelists}
                    fetchHierarchicalCodelists={fetchHierarchicalCodelists}
                    hideVariableTabs={hideVariableTabs}
                  />
                )
            }}
          </DataLanguageConsumer>
        </EnhancedModal>
        <EnhancedModal
          visible={isDsdsListVisible}
          onCancel={onDsdsHide}
          title={t('commons.artefact.tabs.general.dsd.modals.dsdList.title')}
          width={MODAL_WIDTH_LG}
          footer={<Button onClick={onDsdsHide}>{t('commons.buttons.close.title')}</Button>}
        >
          <Call cb={fetchDsds}>
            <ArtefactList
              artefacts={dsds}
              onDetailShow={onDsdDetailShow}
              onRowClick={onDsdSet}
              getIsDisabledRow={({isFinal}) => !isFinal}
            />
          </Call>
        </EnhancedModal>
        <ReduxdsdDetailModal
          instancePrefix={MM_DATAFLOWS_DSD_DETAIL_PREFIX}
          instanceState={dsdDetail}
        />
        <ReduxdsdDetailModal
          instancePrefix={MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX}
          instanceState={selectedDsdDetail}
        />
      </Call>
    </Call>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
)(DataflowDetail);
